import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import Footer from "../../components/footer";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center">
      <div
        className="flex flex-col items-center justify-center space-y-4"
        style={{
          height: "calc(100% - 32px)",
        }}
      >
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-3xl font-medium">Oops! Something went wrong</h1>
          <p>
            An unexpected error has occurred, or the site is currently
            undergoing maintenance.
          </p>
        </div>

        <Button label="Go back to Home" onClick={() => navigate("/")} />
      </div>

      <Footer />
    </div>
  );
}
